import { Component } from '@angular/core';
import { GetService } from './Services/get.service';
import { PostService } from './Services/post.service';
import { Router } from '@angular/router';
import { LoginComponent } from './Components/login/login.component'

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'app';
  isInnerSidebarOpen = false;
  isOuterSidebarOpen = false;
  constructor(private getService: GetService, private router: Router, private postService: PostService) {

  }

  openSideBar() {
    $('.ui.sidebar.inner')
        .sidebar('setting', { transition: 'overlay' })
        .sidebar('toggle')    
  }

  openFamilySidebar() {
    //close inner one
    $('.ui.sidebar.inner') 
        .sidebar('setting', { transition: 'overlay' })
        .sidebar('toggle')    
    //open outer one
    $('.ui.sidebar.family')
        .sidebar('setting','transition','overlay')
        .sidebar('toggle')
  }

  
  openDonorSidebar() {
    //close inner one
    $('.ui.sidebar.inner') 
        .sidebar('setting', { transition: 'overlay' })
        .sidebar('toggle')    
    //open outer one
    $('.ui.sidebar.donor')
        .sidebar('setting','transition','overlay')
        .sidebar('toggle')
  }


  familyCloseSidebar() {
     //open outer one
     $('.ui.sidebar.family')
     .sidebar('setting','transition','overlay')
     .sidebar('toggle')
  }

  donorCloseSidebar() {
    //open outer one
    $('.ui.sidebar.donor')
    .sidebar('setting','transition','overlay')
    .sidebar('toggle')
  }

  logOut() {
    localStorage.removeItem('currentUser');
    this.router.navigate(['home'], {queryParams: { status: "Logged Out" }});
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts